import {ActionLink} from '../../offer/types/actionLink'
import {MealsType} from '../../offer/types/AugmentedOffer'
import {
  CancellationPenalty,
  Chargeable,
  OfferPrice
} from '../../offer/types/offer'
import {ProviderTraderInformation} from '../../provider/types/ProviderTraderInformation'
import {Address} from './BookingRequest'
import {BookingStatus} from './BookingStatus'

export interface BookingData {
  anonymousId: string
  billing: BillingInformation
  cancellationId?: string
  cancellationPenalties: CancellationPenalty[]

  checkIn: string
  checkOut: string
  confirmationId: string
  customer: CustomerInformation
  customerCountryCode: string
  customerIp: string
  customerSupport: CustomerSupportInformation
  hotelId: string
  id: string
  instructions: Instructions
  links: ActionLink[]
  merchantOfRecord: string
  prices: BookingOfferPrice[]
  providerConfirmationId: string
  refundable: boolean
  refund: Refund
  rooms: Room[]
  status: BookingStatus
  payAtProperty?: boolean
  providerTraderInformation?: ProviderTraderInformation
  insertedAt?: string
  /** @deprecated use cancellationPenalties instead */
  cancellationPolicy: {
    deadline: string
    description: string
  }
  source?: BookingSources
  expiresAt?: string | null
  chargedAt?: string | null
  offerId?: string
  cancelledAt?: string | null
  updatedAt?: string | null
  fulfillmentDate?: string | null
  offerMetadata: OfferMetadata
  chargeDueAt?: string | null
  payment?: null | Payment
}

export interface Refund {
  amount: string
  currency: string
  status: 'refunded' | 'to_be_refunded'
}

interface BillingInformation {
  address: Address
  firstName: string
  lastName: string
}

interface CustomerInformation {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
}

interface CustomerSupportInformation {
  email: string
  /** @deprecated use phoneNumber instead */
  phone?: string
  phoneNumber: string
}

interface Instructions {
  checkInEnd: string
  checkInMinimumAge?: string
  checkInStart: string
  checkOutEnd: string
  details: string
}

export interface Room {
  bedTypeName: string
  boardType: MealsType
  confirmationId: string
  firstName: string
  lastName: string
  name: string
  smoking: boolean
  specialRequest: string
  guests: Guests
  id?: string
  masterId?: string
}

export interface Guests {
  adults: number
  childAges: number[]
  children: number
}

export interface BookingOfferPrice extends OfferPrice {
  chargeable: Chargeable & {total: number}
  currencyCode: string
}

export enum BookingSources {
  Default = 'default',
  DealFreeze = 'deal_freeze',
  Rebooking = 'rebooking',
  ChargeLater = 'charge_later'
}

export interface OfferMetadata {
  accessTier: string[]
}

export interface Payment {
  /**
   * Payment method
   */
  method: MethodObject
}

export interface MethodObject {
  /**
   * Card information.
   */
  card: Card
  /**
   * The payment type.
   */
  type: MethodType
}

export interface Card {
  /**
   * The card brand.
   */
  brand: string
  /**
   * The last four digits of the card.
   */
  lastFourDigits: string
}

/**
 * The payment type.
 */
export enum MethodType {
  Card = 'card'
}
